import { BehaviorSubject } from 'rxjs';
import { dwStatusListJson } from './model/http-error-statusList';
var DwHttpErrorStatusList = /** @class */ (function () {
    function DwHttpErrorStatusList() {
        var _this = this;
        var list = dwStatusListJson;
        this.statusList = [];
        this.statusList$ = new BehaviorSubject(this.statusList);
        list.forEach(function (item) {
            _this.statusList[item.status] = item;
        });
        this.statusList$.next(this.statusList);
    }
    Object.defineProperty(DwHttpErrorStatusList.prototype, "dwStatusList", {
        get: function () {
            return this.statusList$;
        },
        enumerable: true,
        configurable: true
    });
    return DwHttpErrorStatusList;
}());
export { DwHttpErrorStatusList };
